
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About MOVIMIENTOS SAO
            </h2>
            <p className="text-base text-gray-600 mb-6 leading-relaxed">
              At MOVIMIENTOS SAO S.R.L., we are dedicated to developing innovative applications that enhance your digital experience. Our flagship VPN solution represents our commitment to providing top-tier security and privacy protection for users worldwide.
            </p>
            <p className="text-base text-gray-600 mb-6 leading-relaxed">
              Based in San Antonio Oeste, Argentina, we combine cutting-edge technology with user-friendly design to create applications that truly make a difference. Our VPN service is built on the foundation of trust, security, and performance.
            </p>
            <p className="text-base text-gray-600 mb-8 leading-relaxed">
              We believe that everyone deserves access to a free and secure internet. That's why we've developed a VPN solution that not only protects your privacy but also delivers exceptional performance without compromising on speed or reliability.
            </p>
            
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-gradient-to-br from-teal-50 to-teal-100 p-6 rounded-lg">
                <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Secure</h3>
                <p className="text-sm text-gray-600">Military-grade encryption</p>
              </div>
              <div className="bg-gradient-to-br from-teal-50 to-teal-100 p-6 rounded-lg">
                <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-rocket-line text-2xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Fast</h3>
                <p className="text-sm text-gray-600">Optimized performance</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/3dcaa1d3b30a46f4b6eba8bb05ca553f.jpg"
                alt="About MOVIMIENTOS SAO"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -left-8 w-64 h-64 bg-teal-600/10 rounded-full blur-3xl"></div>
            <div className="absolute -top-8 -right-8 w-64 h-64 bg-teal-600/10 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
